import React, { useCallback } from "react";
import iconInformacionAsset from "../../../assets/icons/ic-information-circle.svg";
import mailIconAsset from "../../../assets/icons/ic-mail.svg";
import { Spacer } from "../../../components/layout/flex";
import { Row } from "../../../components/layout/flex-layout";
import { TextField } from "../../shared/form-fields/text-field";
import { quotationPopupFormDefinition } from "../constants/form-fields-definition";
import { useEmailAutocomplete } from "../../../hooks/use-email-autocomplete";
import { useQuotationPopupFormContext } from "../hooks/use-quotation-popup-form";

const QuotationPopupContactEmailFieldTooltip: React.FC = () => {
    return (
        <div className="quotation-popup__contact-email__tooltip">
            <img src={iconInformacionAsset} height={16} />
            <div className="quotation-popup__contact-email__tooltip-content">
                <p>
                    Este correo será utilizado como domicilio{"\n"}contractual
                    de la empresa para los efectos de{"\n"}la ejecución del
                    contrato y comunicación del{"\n"}seguro Vida Ley
                </p>
            </div>
        </div>
    );
};

export const QuotationPopupContactEmailField: React.FC = () => {
    const rhForm = useQuotationPopupFormContext();
    const setEmailFieldValue = useCallback(
        (val) => {
            rhForm.setValue("contactEmail", val, { shouldValidate: true });
        },
        [rhForm.setValue]
    );
    const { handleChangeEmail, handleKeyDownEmail } = useEmailAutocomplete(
        quotationPopupFormDefinition.contactEmail.key,
        setEmailFieldValue
    );
    return (
        <TextField
            data-testid="QuotationPopupContactEmailField"
            icon={<img src={mailIconAsset} />}
            fieldDefinition={quotationPopupFormDefinition.contactEmail}
            rhForm={rhForm}
            onKeyDown={handleKeyDownEmail}
            onChange={handleChangeEmail}
            renderLabel={(label) => (
                <Row>
                    {label}
                    <Spacer />
                    <QuotationPopupContactEmailFieldTooltip />
                </Row>
            )}
        />
    );
};
